import React from 'react';
import BookMobile from '../BookMobile';
import BookMobileGlobal from '../BookMobileGlobal';
import Book from '../Book';
import { useRouter } from 'next/router';
import { parseMarketScope } from '@/utils/parseMarketScope';

interface ReviewStepProps {
  isLoading: boolean;
  data: any;
  inputDedication: string;
  product: any;
  childName: string;
  name: string;
  dedicationImage: string | null;
  imageSelected: string;
  bookView: 'single' | 'double';
  isProductRtlInBook: string;
  desktopRef: React.RefObject<any>;
  setStep: (s: 'info' | 'review' | 'edit') => void;
  setActiveOption: (o: string) => void;
  setDedicationModal: (v: boolean) => void;
  productData: any;
  isEdit: string | undefined;
}

export default function ReviewStep({
  isLoading,
  data,
  inputDedication,
  product,
  childName,
  name,
  dedicationImage,
  imageSelected,
  bookView,
  isProductRtlInBook,
  desktopRef,
  setStep,
  setActiveOption,
  setDedicationModal,
  productData,
  isEdit,
}: ReviewStepProps) {
  const { locale } = useRouter();

  if (isLoading) {
    return (
      <div className='flex-1 overflow-y-auto px-4 py-6 bg-[#FFFCEB] flex items-center justify-center gap-4 h-full' id='review-step'>
        <div className="w-6 h-6 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
        <h2 className="text-lg font-semibold leading-none">
          {locale === 'ar' ? 'جاري تحميل الكتاب...' : 'Loading book...'}
        </h2>
      </div>
    );
  }

  const MarketScope = isEdit === '1'
    ? productData?.product?.marketScope || productData?.marketScope
    : product?.market_scope;

  const scopeArray = parseMarketScope(MarketScope);
  const isInIsrael = scopeArray.includes('IL');

  return (
    <div className={`flex-1 overflow-y-auto px-2 ${bookView === 'single' ? 'py-6' : 'py-3'} space-y-6 bg-[#FFFCEB] hide-scrollbar`}>
      {bookView === 'single' ? (
        isInIsrael ? (
          <BookMobile
            key={`book-mobile-${bookView}`}
            pages={data?.pages?.pdf}
            cover_pages={data?.cover_pages?.pdf}
            cover_pages_predefined_texts={data?.cover_pages_predefined_texts}
            inputDedication={inputDedication}
            product={product}
            pages_predefined_texts={data?.pages_predefined_texts}
            pages_dedication_texts={data?.pages_dedication_texts}
            setStep={setStep}
            setActiveOption={setActiveOption}
            setDedicationModal={setDedicationModal}
            name={childName}
            dedicationImage={dedicationImage}
            imageSelected={imageSelected}
            bookView={bookView}
            isProductRtlInBook={isProductRtlInBook}
            isInIsrael={isInIsrael}
            isEditMode={isEdit === '1'}
          />
        ) : (
          <BookMobileGlobal
            key={`book-mobile-${bookView}`}
            pages={data?.pages?.pdf}
            cover_pages={data?.cover_pages?.pdf}
            cover_pages_predefined_texts={data?.cover_pages_predefined_texts}
            inputDedication={inputDedication}
            product={product}
            pages_predefined_texts={data?.pages_predefined_texts}
            pages_dedication_texts={data?.pages_dedication_texts}
            setStep={setStep}
            setActiveOption={setActiveOption}
            setDedicationModal={setDedicationModal}
            name={childName}
            dedicationImage={dedicationImage}
            imageSelected={imageSelected}
            bookView={bookView}
            isProductRtlInBook={isProductRtlInBook}
            isInIsrael={isInIsrael}
            isEditMode={isEdit === '1'}
          />
        )
      ) : (
        <Book
          key={`book-${bookView}`}
          pages={data?.pages.pdf}
          cover_pages={data?.cover_pages.pdf}
          cover_pages_predefined_texts={data?.cover_pages_predefined_texts}
          inputDedication={inputDedication}
          product={product}
          pages_predefined_texts={data?.pages_predefined_texts}
          pages_dedication_texts={data?.pages_dedication_texts}
          desktopRef={desktopRef}
          dedicationImage={dedicationImage}
          imageSelected={imageSelected}
          bookView={bookView}
          isProductRtlInBook={isProductRtlInBook}
          isInIsrael={isInIsrael}
        />
      )}
    </div>
  );
}